import { ReactNode, useState } from "react";
import {
  Button,
  Drawer,
  DrawerOverlay,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import CreateOrderingPlatform from "./Create";
import OrderingPlatformDrawerContent from "./DrawerContent";
import OrderingPlatformDirectory, { OrderingPlatformDirectoryProps } from ".";

const NEW_ID = "__NEW__";

type Props = Omit<ModalProps, "children"> &
  Pick<
    OrderingPlatformDirectoryProps,
    "columns" | "filter" | "isAdmin" | "pinnedColumns" | "meta"
  > & {
    renderDrawerFooter?: (props: { orderingPlatformId: UUID }) => ReactNode;
  };

export default function OrderingPlatformDirectoryModal({
  columns,
  filter,
  isAdmin,
  meta,
  pinnedColumns,
  renderDrawerFooter,
  ...rest
}: Props) {
  const [selectedOrderingPlatformId, setSelectedOrderingPlatformId] =
    useState<UUID | null>(null);
  return (
    <>
      <Modal {...rest} size="6xl" blockScrollOnMount={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Customer Directory</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <OrderingPlatformDirectory
              {...{ columns, filter, isAdmin, pinnedColumns, meta }}
              selected={selectedOrderingPlatformId}
              onSelectedChange={setSelectedOrderingPlatformId}
            />
          </ModalBody>
          <ModalFooter justifyContent="center">
            <Button
              size="sm"
              colorScheme="pinkButton"
              leftIcon={<AddIcon />}
              onClick={() => setSelectedOrderingPlatformId(NEW_ID)}
            >
              Add New Customer
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Drawer
        isOpen={!!selectedOrderingPlatformId}
        placement="right"
        onClose={() => setSelectedOrderingPlatformId(null)}
        size="sm"
        blockScrollOnMount={false}
      >
        <DrawerOverlay />
        {selectedOrderingPlatformId === NEW_ID ? (
          <CreateOrderingPlatform
            isAdmin={isAdmin}
            onCloseEdit={() => setSelectedOrderingPlatformId(null)}
            onCompleted={(newId) => setSelectedOrderingPlatformId(newId)}
          />
        ) : (
          <OrderingPlatformDrawerContent
            isAdmin={isAdmin}
            onClose={() => setSelectedOrderingPlatformId(null)}
            onSelectedOrderingPlatformIdChange={setSelectedOrderingPlatformId}
            selectedOrderingPlatformId={selectedOrderingPlatformId}
            footer={
              selectedOrderingPlatformId &&
              renderDrawerFooter?.({
                orderingPlatformId: selectedOrderingPlatformId,
              })
            }
          />
        )}
      </Drawer>
    </>
  );
}
